import { ReactNode, useCallback, useEffect } from 'react';
import { useAuthProvider } from './AuthProvider';
import { useApiError } from './ApiErrorProvider';
import { useMutation } from '@apollo/client';
import { MUTATE_OFFLINE_MODULE } from '../mutations/common';
import { processOfflineRequests } from '../helpers/initialFormState';

interface Props {
  children: ReactNode;
}

export const OfflineRequestsProvider = ({ children }: Props) => {
  const authContext = useAuthProvider();
  const { setErrorCode } = useApiError();
  const [offlineModuleMutation] = useMutation(MUTATE_OFFLINE_MODULE);

  const handleOnline = useCallback(() => {
    // Only process if authenticated and user has an accessToken
    if (!authContext.isAuthenticated || !authContext.user?.accessToken) return;
    processOfflineRequests({
      isDeviceOffline: false,
      acquireTokenSilently: authContext.acquireTokenSilently,
      offlineModuleMutation,
      setErrorCode,
    });
  }, [authContext, offlineModuleMutation, setErrorCode]);

  useEffect(() => {
    window.addEventListener('online', handleOnline);
    // Optionally, process immediately if already online
    if (navigator.onLine) {
      handleOnline();
    }
    return () => {
      window.removeEventListener('online', handleOnline);
    };
  }, [handleOnline]);

  return <>{children}</>;
}; 